<template>
  <div class="app-container">
    <navigation title="征集/启事"></navigation>
    <div class="list">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-cell v-for="item in list" :to="{name:'newsDetail', query: {id:item.id,title:'征集/启示详情'}}">
          <template #title>
            <div class="message-tit">{{ item.title }}</div>
            <div class="message-tit message-tit-right" v-if="item.subTitle">{{ item.subTitle }}</div>
          </template>
          <template #label>
            <p class="message">{{ item.startTime }}</p>
          </template>
        </van-cell>
      </van-list>
    </div>
    <version></version>
    <scroll></scroll>
  </div>
</template>

<script>
import Vue from 'vue'
import { Cell, CellGroup, List, Icon, Checkbox } from 'vant'
import {request} from '../../untils/request'
import navigation from '../../components/navigation'
import version from '../../components/version'
import scroll from '../../components/scroll'
import {parseTime} from '../../untils/formatTime'

Vue.use(Cell).use(CellGroup).use(List).use(Icon).use(Checkbox)
export default {
  name: 'solicitation',
  components: {navigation, version, scroll},
  data () {
    return {
      list: [],
      loading: false,
      finished: false,
      checked: true,
      choose: true,
      checkAll: false,
      ifManagement: true,
      params: {
        pageNum: '1',
        pageSize: '10'
      }
    }
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    onLoad () {
      // 征集启事
      this.params.type = 'INFORMATION_SOLICITATION'
      request('get', '/nlc-web/api/information', this.params).then(res => {
        for (var i = 0; i < res.data.content.length; i++) {
          res.data.content[i].startTime = parseTime(res.data.content[i].startTime,'{y}-{m}-{d}')
          this.list.push(res.data.content[i])
        }
        // 加载状态结束
        this.loading = false
        if (res.data.totalElements === this.list.length) {
          this.finished = true
        }
      })
      this.params.pageNum++
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'newsDetail') {
      from.meta.keepAlive = true;
    } else {
      from.meta.keepAlive = false;
    }
    next();//不可缺少
  }
}
</script>

<style scoped>
.app-container{
  background:#ecf5fd;
  overflow-y:scroll;
  min-height: calc(100% - 92px);
  position: absolute;
  top: 0px;
  bottom: 0px;
}
.list{
  margin:.29rem .28rem 0 .28rem;
  width:6.94rem;
  border-radius:8px;
  background:#fff;
}
.van-cell{
  padding: 10px 16px 10px 20px !important;
  border-radius:8px;
  background:none;
}
.van-cell__title{
  width:100%;
  font-size:.3rem;
  color:#444649;
  font-family: SourceHanSerifCN-SemiBold;
}
.message{
  line-height:.1rem;
  font-size: .26rem;
  font-family: SourceHanSerifCN-Light;
  margin-bottom:0;
  text-align:right;
}
.state{
  font-size:.24rem;
  color:#94979C;
}
.state-return{
  color:#008095;
}
.van-cell::after{
  border-bottom: 1px solid #B3BBC3;
}
.list{
  margin-top: 1.1rem;
}
.message-tit{
  width:100%;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
  word-wrap:break-word;
}
.message-tit-right{
  text-align:right;
}
</style>



// WEBPACK FOOTER //
// src/view/solicitation/index.vue